import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { combineLatest, fromEvent, Subject } from "rxjs";
import { map, pluck, switchMap, takeUntil } from "rxjs/operators";
import { timeString } from "../../../functions/booking-utils.functions";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { CommuteService } from "../../../services/commute.service";
import { EmpUserService } from "../../../services/emp-user.service";
import { WisConfigService } from "../../../services/wis-config.service";

@Component({
  selector: "[mis-employee-web-exp-parking-grid-floor-plan]",
  templateUrl: "./parking-grid-floor-plan.component.html",
  styleUrls: ["./parking-grid-floor-plan.component.scss"]
})
export class ParkingGridFloorPlanComponent implements OnInit {
  url: string;
  messageStream = fromEvent<any>(window, "message");
  @ViewChild("frameElement") frameElement: ElementRef;
  private endObs = new Subject<void>();

  constructor(
    private userSvc: EmpUserService,
    private commuteSvc: CommuteService,
    private route: ActivatedRoute,
    private wisCfgSvc: WisConfigService
  ) {}

  ngOnInit(): void {
    this.messageStream.pipe(takeUntil(this.endObs)).subscribe(res => {
      const message = res.data;
      if (message?.eventType === "SEAT_SELECTED") {
        this.createCommuteFormData(message);
      }
    });
    this.wisCfgSvc.serviceHosts
      .pipe(
        pluck("empExpStatic"),
        map(url => `${url}/static/pages/page/#/parking-view`),
        switchMap(url => {
          return combineLatest([this.commuteSvc.gridUrlData, this.commuteSvc.allotedParkingDetails]).pipe(
            map(([gridUrlData, parkingData]) => {
              const start = timeString(gridUrlData.startShift.timeInMinutes, gridUrlData.office.timezone, gridUrlData.startDate);
              const end = timeString(gridUrlData.endShift.timeInMinutes, gridUrlData.office.timezone, gridUrlData.startDate);
              if (start === null || end === null || !parkingData?.vehicleType) {
                return "";
              } else {
                let finalUrl: string;
                finalUrl = `${url}?view=parking-view&openedFrom=web&buid=${this.userSvc.employeeInfo.buid}&officeGuid=${gridUrlData.office.value}&empGuid=${this.userSvc.employeeInfo.empGuid}&startTime=${start}&endTime=${end}&type=${parkingData?.vehicleType}`;
                const authToken = this.route.snapshot.queryParamMap.get("auth-token");
                if (authToken) {
                  finalUrl += `&auth-token=${authToken}`;
                }
                if (parkingData?.zoneId && parkingData?.levelId) {
                  finalUrl += `&zoneId=${parkingData?.zoneId}&levelId=${parkingData?.levelId}&seatId=${gridUrlData?.commute?.login?.value?.seatId}`;
                }
                return finalUrl;
              }
            })
          );
        }),
        takeUntil(this.endObs)
      )
      .subscribe(url => {
        this.url = url;
        if (this.frameElement?.nativeElement) {
          this.frameElement.nativeElement.src = this.url;
          const element = this.frameElement.nativeElement;
          if (element.parentNode?.replaceChild) element.parentNode.replaceChild(element, element);
        }
      });
  }

  createCommuteFormData(message, regNo?: string) {
    let value: NsEmpWebExpData.IParkingPremise;
    this.commuteSvc.allotedParkingDetails.subscribe(premiseType => {
      value = {
        premise: message?.value?.floorName,
        premiseId: message?.value?.floorId,
        premiseType: premiseType?.vehicleType,
        seatId: message?.value?.seatId,
        seatName: message?.value?.seatName
      } as NsEmpWebExpData.IParkingPremise;
    });
    const opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?] = [
      message.value ? { id: "parking", value: value, disable: false } : undefined,
      undefined
    ];
    this.commuteSvc.setCommute(opt);
  }
  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }
}
